/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/dataStatistics',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '数据统计',
      icon: 'component',
    },
    children: [
      {
        path: '/dataStatistics/searchStatistics',
        component: () => import('@/myviews/shoppMall/dataStatistics/searchStatistics/searchStatistics.vue'),
        alwaysShow: false,
        name: 'SearchStatistics',
        meta: {
          title: '搜索统计',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataStatistics/commodityStatistics',
        component: () => import('@/myviews/shoppMall/dataStatistics/commodityStatistics/commodityStatistics.vue'),
        alwaysShow: false,
        name: 'CommodityStatistics',
        meta: {
          title: '商品统计',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataStatistics/floorStatistics',
        component: () => import('@/myviews/shoppMall/dataStatistics/floorStatistics/floorStatistics.vue'),
        alwaysShow: false,
        name: 'FloorStatistics',
        meta: {
          title: '楼层统计',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataStatistics/flowStatistics',
        component: () => import('@/myviews/shoppMall/dataStatistics/flowStatistics/flowStatistics.vue'),
        alwaysShow: false,
        name: 'FlowStatistics',
        meta: {
          title: '流量统计',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataStatistics/transactionStatistics',
        component: () => import('@/myviews/shoppMall/dataStatistics/transactionStatistics/transactionStatistics.vue'),
        alwaysShow: false,
        name: 'TransactionStatistics',
        meta: {
          title: '交易统计',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/dataStatistics/activityStatistics',
        component: () => import('@/myviews/shoppMall/dataStatistics/activityStatistics/activityStatistics.vue'),
        alwaysShow: false,
        name: 'ActivityStatistics',
        meta: {
          title: '活动统计',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/shoppMall/dataStatistics.js